import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Baby, CheckCircle2, Lock, CreditCard, Users, Star, MapPin } from 'lucide-react';
export const Hero = () => {
  return <section className="relative py-8 sm:py-12 lg:py-20 overflow-hidden bg-cream" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-117">
        <div className="max-w-3xl mx-auto text-center" data-id="element-118">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-119">
            <div className="inline-block bg-brand-green/10 text-brand-green font-semibold px-4 py-1.5 rounded-full text-sm mb-4 sm:mb-6 border border-brand-green/20" data-id="element-120">
              KIT EPILEPSIA BAJO CONTROL™ 2026 — SISTEMA DE MANEJO DE EPILEPSIA
              INFANTIL
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold mb-4 sm:mb-6 text-[#213664] leading-tight" data-id="element-121">
              El próximo episodio puede ser mañana. Tomá el control de la
              epilepsia de tu hijo desde esta semana.
            </h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-4 sm:mb-6" data-id="element-122">
              <div className="absolute inset-0 bg-brand-amber/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-123"></div>
              <img src="https://cdn.magicpatterns.com/uploads/8SnMu2HrvRmMbbsxqoj4Bz/fedbfdd6-70c3-4cb2-8d43-95ad4a170047.png" alt="Kit Epilepsia Bajo Control 2026 Sistema de Manejo de Epilepsia Infantil" className="w-[70%] max-w-[33.6rem] mx-auto drop-shadow-2xl" loading="eager" data-id="element-124" />
            </motion.div>

            <p className="text-lg sm:text-xl md:text-2xl font-heading font-semibold text-brand-green mb-3 sm:mb-4" data-id="element-125">
              Sistema Integral de Manejo de Epilepsia Infantil
            </p>

            <div className="inline-flex items-center gap-2 bg-brand-gold text-white font-bold px-4 py-2 rounded-lg mb-4 sm:mb-6 shadow-sm" data-id="element-126">
              <span className="text-xl" data-id="element-127">4 + 3</span>
              <span className="text-sm uppercase tracking-wider" data-id="element-128">
                Tomos + Bonos
              </span>
            </div>

            <p className="text-base sm:text-lg text-gray-700 mb-6 sm:mb-8 leading-relaxed px-4" data-id="element-129">
              Tu hijo puede vivir mejor esta semana: protocolos de crisis,
              alimentación cetogénica, plan de acción escolar y manejo emocional
              familiar.{' '}
              <span className="font-bold border-b-2 border-brand-orange" data-id="element-130">
                Sin improvisar. Sin entrar en pánico cuando empiece a
                convulsionar.
              </span>
            </p>

            <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-6 sm:mb-10" data-id="element-131">
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-132">
                <FileText size={14} className="text-brand-orange" data-id="element-133" /> PDF Digital
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-134">
                <Zap size={14} className="text-brand-amber" data-id="element-135" /> Acceso Inmediato
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-136">
                <Baby size={14} className="text-brand-green" data-id="element-137" /> Para Niños de 2
                a 16 Años
              </span>
              <span className="flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium text-gray-700 shadow-sm border border-gray-100" data-id="element-138">
                <CheckCircle2 size={14} className="text-brand-gold" data-id="element-139" /> Adaptado
                al Sistema de Salud y Contexto Argentino 2026
              </span>
            </div>

            <motion.button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto bg-brand-orange hover:bg-brand-orange/90 text-white font-bold text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-xl shadow-soft transform transition hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-140">
              💥 QUIERO EL CONTROL DE LA EPILEPSIA DE MI HIJO AHORA
            </motion.button>

            <div className="mt-6 sm:mt-8 flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-600 font-medium" data-id="element-141">
              <span className="flex items-center gap-1.5" data-id="element-142">
                <CheckCircle2 size={14} className="text-green-600" data-id="element-143" /> Garantía 7
                días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-144">
                <Lock size={14} className="text-gray-500" data-id="element-145" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-146">
                <CreditCard size={14} className="text-blue-500" data-id="element-147" /> Mercado Pago
              </span>
              <span className="flex items-center gap-1.5" data-id="element-148">
                <Users size={14} className="text-brand-orange" data-id="element-149" /> +500 Mamás
              </span>
              <span className="flex items-center gap-1.5" data-id="element-150">
                <Star size={14} className="text-brand-gold fill-brand-gold" data-id="element-151" />{' '}
                4.9 Rating
              </span>
              <span className="flex items-center gap-1.5" data-id="element-152">
                <MapPin size={14} className="text-brand-green" data-id="element-153" /> Todo Argentina
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};